module.exports = __webpack_public_path__ + "static/img/tab111.f1a58db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabimg/tab111.png
// module id = Yb4I
// module chunks = 1